import type { QueryFunctionContext } from "react-query";
import { useQuery, type UseQueryOptions } from "react-query";

import { fetchClient } from "@/lib/fetchClient";
import type { GetFolderResponse } from "@/types/resources";

async function getFolders({
  signal,
}: QueryFunctionContext): Promise<GetFolderResponse> {
  const { data } = await fetchClient.GET("/folders", {
    signal,
  });
  if (data === undefined) {
    throw new Error("Failed to fetch folders");
  }
  return data;
}

type UseGetFoldersOptions = {
  config?: UseQueryOptions<GetFolderResponse>;
};

export const useGetFolders = ({ config }: UseGetFoldersOptions = {}) => {
  return useQuery({
    queryKey: ["folders"],
    queryFn: getFolders,
    ...config,
  });
};
